import { render, staticRenderFns } from "./CustomUIProject.vue?vue&type=template&id=4e6da7ff&scoped=true"
import script from "./CustomUIProject.vue?vue&type=script&lang=js"
export * from "./CustomUIProject.vue?vue&type=script&lang=js"
import style0 from "./CustomUIProject.vue?vue&type=style&index=0&id=4e6da7ff&prod&scoped=true&lang=css"
import style1 from "./CustomUIProject.vue?vue&type=style&index=1&id=4e6da7ff&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6da7ff",
  null
  
)

export default component.exports